import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=4149114f&"
import script from "./LeadDetails.vue?vue&type=script&lang=js&"
export * from "./LeadDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports